var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 166,
    viewBox: "0 0 83 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1107 83C57.1107 114.541 31.5414 140.111 -6.12443e-06 140.111L-5.48682e-06 125.524C23.4852 125.524 42.5237 106.485 42.5237 83C42.5237 59.5148 23.4852 40.4763 1.34895e-05 40.4762L1.41271e-05 25.8893C31.5414 25.8893 57.1107 51.4586 57.1107 83Z",
    fill: "#DAB9E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 83C83 128.84 45.8396 166 -7.25609e-06 166L-6.61847e-06 151.413C37.7835 151.413 68.413 120.783 68.413 83C68.413 45.2165 37.7835 14.587 2.22506e-05 14.587L2.28882e-05 -3.62804e-06C45.8396 2.3831e-06 83 37.1604 83 83Z",
    fill: "#DAB9E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3982 83C32.3982 100.893 17.8931 115.398 -5.04422e-06 115.398L-4.4066e-06 100.811C9.83688 100.811 17.8113 92.8369 17.8113 83C17.8113 73.1631 9.83689 65.1888 1.24093e-05 65.1888L1.30469e-05 50.6018C17.8931 50.6018 32.3982 65.107 32.3982 83Z",
    fill: "#DAB9E2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape-3.69f3405ebbd549c89a30b02ffca48149.svg";
export { ForwardRef as ReactComponent };